export const SCENES = {
  UNBIND_GOOGLE_2FA: '60006',
  API_MANAGEMENT_EDIT_IP: '30080',
  MAIN_ACCOUNT_EDIT_SUB_ACCOUNT_API: '30079',
  SUB_ACCOUNT_LOGIN: '30078',
  VIEW_API_SECRET_PWD: '30091',
  BIND_THIRD_APP_TELEGRAM: '30093',
  UNBIND_THIRD_APP_TELEGRAM: '30094',
  ANTIPHISHING_CODE: '31001',
  OPEN_ONLY_ADDRESS_BOOK_WITHDRAW: '30202',
  CLOSE_ONLY_ADDRESS_BOOK_WITHDRAW: '30203',
  OPEN_NEW_ADDRESS_WITHDRAW_LIMIT: '30204',
  CLOSE_NEW_ADDRESS_WITHDRAW_LIMIT: '30205',
  OPEN_FETCH_COIN_NOT_AUTH: '30060',
  CLOSE_FETCH_COIN_NOT_AUTH: '30201',
  MODIFY_PASSWORD: '30206',
  DELETE_ACCOUNT: '30211',
};
